import { format as dateFnsFormat } from 'date-fns'
import fr from 'date-fns/locale/fr'

export const format = (
  date: Date | string | number,
  dateFormat: string
): string => dateFnsFormat(date, dateFormat, { locale: fr })
